export const HEARTBEAT_INTERVAL_MS = 15_000;
export const HEARTBEAT_STALE_MS = 45_000;
const FUTURE_TOLERANCE_MS = 5_000;

export function isFreshHeartbeat(iso: string | undefined, nowMs: number): boolean {
  if (!iso) return false;
  const beatMs = Date.parse(iso);
  if (Number.isNaN(beatMs)) return false;
  if (beatMs - nowMs > FUTURE_TOLERANCE_MS) return false;
  return nowMs - beatMs <= HEARTBEAT_STALE_MS;
}

export type BridgeStatus =
  | { kind: 'live-here' }
  | { kind: 'live-elsewhere'; eventName: string }
  | { kind: 'lost' }
  | { kind: 'none' };

export function getBridgeStatus(
  lock: { eventId: string; eventName: string; heartbeatAt?: string } | null,
  eventId: string | undefined,
  nowMs: number,
): BridgeStatus {
  if (!lock?.heartbeatAt) return { kind: 'none' };
  const sameEvent = lock.eventId === eventId;
  if (isFreshHeartbeat(lock.heartbeatAt, nowMs)) {
    return sameEvent ? { kind: 'live-here' } : { kind: 'live-elsewhere', eventName: lock.eventName };
  }
  return sameEvent ? { kind: 'lost' } : { kind: 'none' };
}
